import { Suspense, lazy } from 'react';
import { Spinner } from './ui.jsx';

// Leaflet is loaded only when a plot map is actually shown, as with MapPanel.
const ParcelMapView = lazy(() => import('./ParcelMapView.jsx'));

const ParcelMap = (props) => (
  <Suspense
    fallback={
      <div className="map-loading" style={{ height: props.height ?? 420 }}>
        <Spinner label="Loading the map" />
      </div>
    }
  >
    <ParcelMapView {...props} />
  </Suspense>
);

export default ParcelMap;

/** Plot sizes as people say them. */
export const plotSize = (sqm) =>
  !sqm ? '-' : sqm >= 10000 ? `${(sqm / 10000).toLocaleString('en', { maximumFractionDigits: 2 })} ha` : `${Math.round(sqm).toLocaleString('en').replace(/,/g, ' ')} m2`;

export const REGISTER_EVENT_TONE = {
  registered: 'info',
  verified: 'good',
  rejected: 'bad',
  listed: 'info',
  under_offer: 'warn',
  sold: 'warn',
  ownership_transferred: 'good',
  conflict_reported: 'bad',
  conflict_resolved: 'good',
  transfer_disputed: 'bad'
};
